import Typography from '@mui/material/Typography'
import { styled } from '@mui/material/styles'
import { colors, componentSizes } from '@theme/variables'

export const AssetsOverviewSubSectionTitle = styled(Typography)`
  padding: ${componentSizes.smDistance} 0;
`

export const SelectDelimeter = styled('div')`
  margin: 0 8px;
  height: 16px;
  width: 0px;
  border-right: 1px solid ${colors.lightGrey};
`
